import type { PersonForm } from '@appTypes/common/types';
import type { CompletePersonProfile, PutEmail } from '@appTypes/esb';

import { trimObject } from './trimFields';

export default function formatEmails(
  formEmails: PersonForm['emails'] = {},
  profileEmails: CompletePersonProfile['emails'] = [],
): PutEmail[] {
  const formattedEmails: PutEmail[] = [];

  Object.entries(formEmails).forEach(([key, email]) => {
    const foundProfileEmail = profileEmails.find(
      profileEmail => profileEmail.id == key.split('_')[1],
    );

    if (email.email === '') {
      return;
    }

    if (foundProfileEmail) {
      formattedEmails.push({
        ...trimObject(foundProfileEmail),
        ...trimObject(email),
        typeId: Number(foundProfileEmail.typeId),
        id: Number(foundProfileEmail.id),
      });
      return;
    }

    formattedEmails.push({
      ...email,
      typeId: 1,
      isUndeliverable: false,
    });
  });

  return formattedEmails;
}
